export enum Apps {
  Unknown = 0,
  TPMPortal = 1,
  POS = 2,
  Donation = 3,
  Lister = 4,
  AdminPortal = 5,
  CompanyPortal = 6,
  IMS = 7,
}
export enum UserType {
  Unknown = 0,
  AppUser,
  ServiceUser,
  ApiUser,
}
export enum SubscriptionPlanType {
  Unknown = 0,
  Self = 1,
  SalesAssisted = 2,
}

export enum LicenseAttributeType {
  Unknown = 0,
  BasePrice = 1,
  NoOfLicenses = 2,
  AdditionalPricePerLicense = 3,
  AllowedAdditionalLicenses = 4,
  NoOfAdditionalLicenses = 5,
}

export enum Status {
  Unknown = 0,
  Draft = 1,
  Active = 2,
  Inactive = 3,
}
export enum UserStatus {
  Unknown,
  Active,
  Inactive,
  Pending,
}
export enum UserInvitationStatus {
  Unknown = 0,
  Accepted = 1,
  InvitationSent = 2,
  Expired = 3,
  NotInvited = 4,
}
export enum CallbackRequestStatus {
  Unknown = 0,
  Pending = 1,
  Completed = 2,
  Cancelled = 3,
}
export enum WarehouseLocationFormatType {
  Unknown = 0,
  ARSB = 1,
  Standard = 2,
}
export enum AddressType {
  Unknown = 0,
  Home,
  Office,
  Billing,
  Shipping,
  Postal,
}

export enum BillingCycle {
  Monthly = 1,
  Yearly_PaidMonthly = 2,
  Yearly_PaidYearly = 3,
}

export enum DiscountType {
  Unknown = 0,
  NoDiscount = 1,
  Percentage = 2,
  Amount = 3,
}
// pagination.constants.ts
export const PageSizes: number[] = [15, 30, 45];

export enum GoalType {
  Unknown = 0,
  UserGoals = 1,
  StoreGoals = 2,
}

export enum TPMUserModules {
  Admin = 3,
  Production = 2,
}
export enum AppPlatform {
  Unknown = 0,
  Android = 1,
  Windows = 2,
}

export enum AppEnvironment {
  Unknown = 0,
  Development = 1,
  Testing = 2,
  Staging = 3,
  PreProduction = 4,
  Production = 5,
}

export enum MobileApp {
  Unknown = 0,
  TpmOffline = 1,
  PosOnline = 2,
}

export enum PrinterType {
  Unknown = 0,
  ZebraLabel = 1,
  ZebraTag = 2,
  ZebraBoth = 3,
}

export enum LabelImageType {
  FrontImage = 0,
  BackImage = 1,
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}
